const SETUP_SLUG_TO_CODE = {
  "aditional-cost": "setup.additional-cost",
  agent: "setup.agent",
  "agent-transport": "setup.agent-transport",
  branch: "setup.branch",
  "cargo-type": "setup.cargo-type",
  "carrier-partner-point": "carrier-partner",
  city: "setup.city",
  country: "setup.country",
  "courier-current-stock": "setup.courier-current-stock",
  device: "setup.device",
  dimension: "setup.dimension",
  "extra-packaging": "setup.extra-packaging",
  "item-category": "setup.item-category",
  "item-type": "setup.item-type",
  "measurement-unit": "setup.measurement-unit",
  "parcel-status": "setup.parcel-status",
  pickup: "setup.pickup",
  "prohibited-item": "setup.prohibited-item",
  route: "setup.route",
  "scanning-point": "setup.scanning-point",
  shiping: "setup.shipping-service",
  "sub-branch": "setup.sub-branch",
  "vat-configuration": "setup.vat-configuration",
  weight: "setup.weight",
  "delivery-plan": "setup.delivery-plan",
  "delivery-setup": "setup.delivery-setup",
};

const PATH_TO_CODE = {
  "/admin-dashboard": "dashboard",
  "/admin-dashboard/analytics": "analytics",
  "/admin-dashboard/issue": "issue",
  "/admin-dashboard/inquiry": "inquiry",
  "/admin-dashboard/bookings": "bookings",
  "/admin-dashboard/walk-in-booking": "walk-in-booking",
  "/admin-bookings": "walk-in-booking",
  "/admin-dashboard/carrier-partner": "carrier-partner",
  "/admin-dashboard/invoice-manager": "invoice-manager",
  "/admin-dashboard/payment": "payment",
  "/admin-dashboard/settings/tracking-integration":
    "settings.tracking-integration",
  "/admin-dashboard/settings/roles-permissions": "roles-permissions",
  "/admin-dashboard/agent-box-ssign": "agent-box-assign",
  "/admin-dashboard/parcel-status-scan": "parcel-status-scan",
  "/admin-dashboard/parcel-setup-cost": "parcel-setup-cost",
  "/admin-dashboard/transport-agent-assigning": "transport-agent-assigning",
  "/admin-dashboard/print-box-serial-barcode": "print-box-serial-barcode",
  "/admin-dashboard/print-barcode": "print-barcode",
  "/admin-dashboard/crm/dashboard": "crm.dashboard",
  "/admin-dashboard/crm/queries": "crm.queries",
  "/admin-dashboard/crm/orders": "crm.orders",
  "/admin-dashboard/crm/tasks": "crm.tasks",
  "/admin-dashboard/crm/activity": "crm.activity",
  "/admin-dashboard/crm/inbox": "crm.inbox",
};

export const DELIVERY_SETUP_CHILD_CODES = [
  "setup.route",
  "setup.measurement-unit",
  "setup.dimension",
  "setup.item-category",
  "setup.delivery-plan",
  "setup.weight",
  "setup.item-type",
];

export function canAccessDeliverySetup(canViewFn) {
  if (typeof canViewFn !== "function") return false;
  if (canViewFn("setup.delivery-setup")) return true;
  return DELIVERY_SETUP_CHILD_CODES.some((code) => canViewFn(code));
}

export const CRM_SCREEN_CODES = [
  "crm.dashboard",
  "crm.queries",
  "crm.orders",
  "crm.tasks",
  "crm.activity",
  "crm.inbox",
];

export function canAccessCrm(canViewFn) {
  if (typeof canViewFn !== "function") return false;
  return CRM_SCREEN_CODES.some((code) => canViewFn(code));
}

export function setupSlugToScreenCode(slug) {
  return SETUP_SLUG_TO_CODE[slug] || (slug ? `setup.${slug}` : null);
}

export function screenCodeFromPath(pathname) {
  const clean = String(pathname || "").replace(/\/+$/, "") || "/";
  if (PATH_TO_CODE[clean]) return PATH_TO_CODE[clean];

  const setupMatch = clean.match(/\/admin-dashboard\/setup\/([^/]+)$/);
  if (setupMatch) return setupSlugToScreenCode(setupMatch[1]);

  return null;
}

export { SETUP_SLUG_TO_CODE };
